// event listener for add
(function() {
    $(document).on('click', '.upsell-atc', function(event) {
        let $upsell = $(event.target).closest('.upsell-product');
        let upsell_variant_id = $upsell.attr('data-variant-id');
        let upsell_selling_plan = $upsell.attr('data-selling-plan');
        let variant_to_remove = $upsell.attr('data-to-remove');

        let update_data = {
        }

        update_data[variant_to_remove] = 0;

        console.log('update data?', update_data);

        let add_data = {
            "id": upsell_variant_id,
            "quantity": 1,
            "selling_plan": upsell_selling_plan
        }

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {updates:update_data},
            dataType: 'json'
        }).done(function(response){
            console.log('cart update success:', response);

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: add_data,
                dataType: 'json',
                success: function() { 
                    console.log('upsell add success!');
                    window.SLIDECART_UPDATE(() => {
                        console.log('slidecart update!')
                    })
                }
            });
        });
    })
})();

function _handleUpsells(cart) {
    $('#cartUpsells').empty();

    let eligible_for_upsell = false;
    let upsell_price = false;
    let upsell_title = false;
    let upsell_variant_id = false;
    let upsell_selling_plan = false;
    let to_remove = false;
    
    // serum
    cart.items.forEach((item) => {

        if (item.variant_id === 40164752556231) {
            eligible_for_upsell = true;
            to_remove = item.variant_id;
            upsell_variant_id = 43743631835366;
            upsell_selling_plan = 5200871654;

            if (item.url.includes('selling_plan=4473333959')) {
                upsell_price = '30';
                upsell_title = 'ADD PHYLA CARE';
            } else {
                upsell_price = '19';
                upsell_title = 'ADD PHYLA CARE';
            }
        }

    });

    // phyla+
    cart.items.forEach((item) => {

        if (item.variant_id === 40147834306759) {
            eligible_for_upsell = true;
            to_remove = item.variant_id;
            upsell_variant_id = 43743309725926;
            upsell_selling_plan = 5200838886;

            if (item.url.includes('selling_plan=473366727')) {
                upsell_price = '30';
                upsell_title = 'UPGRADE TO PHYLA+';
            } else {
                upsell_price = '9';
                upsell_title = 'UPGRADE TO PHYLA+';
            }
        }

    });

    cart.items.forEach((item) => {
        if (item.variant_id === 43743309725926 || item.variant_id === 43743631835366) {
            eligible_for_upsell = false;
        }
    });

    if (!eligible_for_upsell) {
        return false;
    }
    
    let upsell_html = `
    <div class="upsell-product-wrap">

        <div class="upsell-product" data-variant-id="${upsell_variant_id}" data-selling-plan="${upsell_selling_plan}" data-to-remove="${to_remove}">
            <h3 class="upsell-title">${upsell_title}</h3>
            <div class="upsell-selling-points">
                <p>&#x2022; Unlimited 1:1 consultations</p>
                <p>&#x2022; A personalized acne care plan</p>
                <p>&#x2022; 24/7 SMS support</p>
            </div>
            <button class="button upsell-atc">UPGRADE NOW +$${upsell_price}</button>
            <p class="upsell-disclaimer">*Renews every 60 days</p>
        </div>


        <div class="upsell-image-wrap">
            <img src="https://cdn.shopify.com/s/files/1/0568/7368/1095/files/Phyla_PDPimageNEW_EDIT050823.jpg?v=1684171183" alt="Upgrade to Phyla+">
        </div>
    
    </div>
    `
    $('#cartUpsells').html(upsell_html);
}

// Temp disable: 7.18.23 - Phyla+/Phyla Care upsells will not fire.
// window.SLIDECART_UPDATED = function(cart) {
//     // Fires whenevr slide cart has updated
//     _handleUpsells(cart);
// }